export const PAYMENTS_PER_PAGE = 15;
export const DEFAULT_CURRENCY = 'EUR';
export const DEFAULT_LOCALE = 'de';
